const SkillsCardSkeleton = () => (
  <article className="experience__details">
    <div className="skeleton skeleton__icon" />
    <div>
      <div className="skeleton skeleton__title" />
      <div className="skeleton skeleton__subtitle" />
    </div>
  </article>
);

export default SkillsCardSkeleton;
